import Vue from "vue";
import VueRouter from "vue-router";
import Top from "../views/Top.vue";
// import SignUp from "../views/SignUp.vue";
import Login from "../views/Login.vue";
import LoginMagicNumber from "../views/LoginMagicNumber.vue";
import Profile from "../views/Profile.vue";
import MyPage from "../views/MyPage.vue";
import RoomManagement from "../views/RoomManagement.vue";
import Information from "../views/Information.vue";
import InformationDetail from "../views/information/Detail.vue";
import MeetingTop from "../views/Meeting/Index.vue";
import MeetingDetail from "../views/Meeting/Detail.vue";
import AdminMeetingParticipants from "../views/admin/meeting/Participants.vue";
import BODIndex from "../views/BoardOfDirectors/Index.vue";
import BODAchives from "../views/BoardOfDirectors/Archives.vue";
// import Achives from "../views/Archives.vue";
import ArchiveIndex from "../views/Archive/Index.vue";
import ArchiveList from "../views/Archive/List.vue";
// import BODBBS from "../views/BoardOfDirectors/BBS.vue";
import BODDetail from "../views/BoardOfDirectors/Detail.vue";
import BODParticipants from "../views/BoardOfDirectors/Participants.vue";
import AdminBODEdit from "../views/admin/bod/Edit.vue";
import NotFound from "../views/NotFound.vue";
import AdminInformation from "../views/admin/information/Index.vue";
import AdminInformationEdit from "../views/admin/information/Edit.vue";
import AdminMeetingindex from "../views/admin/meeting/Index.vue";
import AdminMeetingEdit from "../views/admin/meeting/Edit.vue";
import AdminMeetingTeamsSend from "../views/admin/meeting/Message.vue";
import ETohyo from "../views/ETohyo.vue";
import ChatAdmin from "../views/admin/meeting/ChatAdmin.vue";
import AdminUserIndex from "../views/admin/user/Index.vue";
import AdminUserEdit from "../views/admin/user/Edit.vue";
import AdminArchiveEdit from "../views/admin/archive/Edit.vue";
import Sso from "../views/Sso.vue";
// import Viewer from "../../public/pdfjs/web/viewer.html";
import RedirectToETohyo from "../views/RedirectToETohyo.vue";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "top",
    component: Top,
    meta: { title: "トップ", desc: "トップ" },
  },
  {
    path: "/mypage",
    name: "mypage",
    component: MyPage,
    meta: { title: "マイページ", desc: "マイページ" },
  },
  {
    path: "/etohyo",
    name: "etohyo",
    component: ETohyo,
    meta: { title: "出欠の提出", desc: "マイページ" },
  },
  {
    path: "/roommanagement",
    name: "roommanagement",
    component: RoomManagement,
  },
  {
    path: "/information/:id",
    name: "information-detail",
    component: InformationDetail,
    meta: { title: "お知らせ", desc: "" },
  },
  {
    path: "/information",
    name: "information-1",
    component: Information,
    alias: "/information/-1",
    meta: { title: "お知らせ", desc: "" },
  },
  // {
  //   path: "/documents",
  //   name: "documents",
  //   component: Achives,
  //   meta: { title: "規約・届出書類", desc: "" },
  // },
  {
    path: "/archive",
    name: "archive",
    component: ArchiveIndex,
    meta: { title: "マンション書庫", desc: "" },
  },
  {
    path: "/archive/:category",
    name: "archive-list",
    component: ArchiveList,
    meta: { title: "マンション書庫一覧", desc: "" },
  },
  {
    path: "/admin/archive/edit/:id",
    name: "admin-archive-edit",
    component: AdminArchiveEdit,
    meta: { title: "[管理]マンション書庫ファイル登録", desc: "" },
  },

  {
    path: "/admin/information",
    name: "admin_information",
    component: AdminInformation,
    meta: { title: "[管理]お知らせ", desc: "" },
  },
  {
    path: "/admin/information/edit/:id",
    name: "admin_information_edit",
    component: AdminInformationEdit,
    meta: { title: "[管理]お知らせ編集", desc: "" },
  },
  {
    path: "/meeting",
    name: "meeting",
    component: MeetingTop,
    meta: { title: "総会", desc: "" },
  },
  {
    path: "/meeting/:id",
    name: "meetingDetail",
    component: MeetingDetail,
    meta: { title: "総会詳細", desc: "" },
  },
  {
    path: "/admin/meeting/participants/:id",
    name: "adminMeetingParticipants",
    component: AdminMeetingParticipants,
    meta: { title: "[管理]総会参加者", desc: "" },
  },
  {
    path: "/admin/meeting",
    name: "admin_meeting_index",
    component: AdminMeetingindex,
    meta: { title: "[管理]総会", desc: "" },
  },
  {
    path: "/admin/meeting/edit/:id",
    name: "admin_meeting_edit",
    component: AdminMeetingEdit,
    meta: { title: "[管理]総会編集", desc: "" },
  },
  {
    path: "/admin/meeting/teams-send/:id",
    name: "admin_meeting_teams_send",
    component: AdminMeetingTeamsSend,
    meta: { title: "[管理]総会メッセージ送信", desc: "" },
  },
  {
    path: "/boardofdirectors",
    name: "bod",
    component: BODIndex,
    meta: { title: "理事会", desc: "" },
  },
  {
    path: "/boardofdirectors/detail/:id",
    name: "bodDetail",
    component: BODDetail,
    meta: { title: "理事会詳細", desc: "" },
  },
  {
    path: "/boardofdirectors/participants/:id",
    name: "bod-Participants",
    component: BODParticipants,
    meta: { title: "理事会", desc: "" },
  },
  {
    path: "/boardofdirectors/archives",
    name: "bodArchives",
    component: BODAchives,
    meta: { title: "理事会書類", desc: "" },
  },
  // {
  //   path: "/boardofdirectors/bbs",
  //   name: "bbs",
  //   component: BODBBS,
  // },
  {
    path: "/admin/bod/edit/:id",
    name: "admin_bod_edit",
    component: AdminBODEdit,
    meta: { title: "[管理]理事会編集", desc: "" },
  },
  {
    path: "/admin/user",
    name: "admin_user",
    component: AdminUserIndex,
    meta: { title: "[管理]ユーザ管理", desc: "" },
  },
  {
    path: "/admin/user/edit/:id",
    name: "admin_user_edit",
    component: AdminUserEdit,
    meta: { title: "[管理]ユーザ編集", desc: "" },
  },
  // {
  //   path: "/signup",
  //   name: "SignUp",
  //   component: SignUp,
  // },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/login-magic-number",
    name: "login-magic-number",
    component: LoginMagicNumber,
  },
  {
    path: "/sso",
    name: "sso",
    component: Sso,
  },
  {
    path: "/redirect-to-etohyo",
    name: "redirect-to-etohyo",
    component: RedirectToETohyo,
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
  },
  {
    path: "/admin/chat/:id",
    name: "admin-chat",
    component: ChatAdmin,
    meta: { title: "[管理]チャット管理", desc: "" },
  },
  // {
  //   test: /\.(html)$/,
  //   exclude: /(node_modules)/,
  //   use: {
  //     loader: "html-loader",
  //   },
  // },
  {
    path: "/404",
    name: "notfound404",
    component: NotFound,
  },
  {
    path: "*",
    name: "notfound",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    // if (savedPosition) {
    //   return savedPosition;
    // } else {
    return { x: 0, y: 0 };
    // }
  },
});

export default router;
